import { useTranslation } from 'react-i18next';

import { InternalPage, HomeLink } from 'theSource/components';
import { CommunicationPreferencesForm } from 'enrollment/features/CommunicationPreferences';

export const CommunicationPreferences = () => {
  const { t } = useTranslation('pages.communicationPreferencesLumos');

  return (
    <InternalPage
      testId="questionnaire-page"
      title={t('title')}
      isLoading={false}
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <CommunicationPreferencesForm />
    </InternalPage>
  );
};
